import React from "react";
import ViewForm from "./ViewForm/ViewForm";
import { API_URLS } from "../../../../api/apiUrls";
const AddManualQuestions = () => {
  return (
    <div className="h-full px-5 pb-5 bg-white ">
      <ViewForm
        sectionurl={API_URLS.GET_SECTIONS}
        subsectionurl={API_URLS.GET_SUBSECTIONS}
        questionurl={API_URLS.GET_CUSTOM_QUESTION}
      />
    </div>
  );
};

export default AddManualQuestions;
